'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var Rating = _interopDefault(require('@material-ui/lab/Rating'));
var styledComponents = require('./styled-components.js');

var StarScores = function (_a) {
    var averageRating = _a.averageRating, disabled = _a.disabled, readOnly = _a.readOnly, _b = _a.style, style = _b === void 0 ? {} : _b, _c = _a.onChange, onChange = _c === void 0 ? function () { return undefined; } : _c, _d = _a.backgroundHidden, backgroundHidden = _d === void 0 ? false : _d, fontSize = _a.fontSize;
    if (backgroundHidden) {
        return (React__default.createElement(styledComponents.Ratings, { style: tslib.__assign({ width: '100%' }, style), fontSize: fontSize },
            React__default.createElement(styledComponents.FullStar, { style: { width: averageRating * 20 + "%" } },
                React__default.createElement(Rating, { className: 'backgroundStarsHidden', value: averageRating, disabled: disabled, readOnly: readOnly, onChange: onChange }))));
    }
    return (React__default.createElement(styledComponents.Ratings, { style: style, fontSize: fontSize },
        React__default.createElement(styledComponents.EmptyStar, null,
            React__default.createElement(Rating, { value: 0, disabled: disabled, readOnly: readOnly })),
        React__default.createElement(styledComponents.FullStar, { "data-testid": 'full-star', style: { width: averageRating * 20 + "%" } },
            React__default.createElement(Rating, { value: averageRating, disabled: disabled, readOnly: readOnly, onChange: onChange }))));
};

module.exports = StarScores;
